var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-rich-text"},[_c('VueHtml5Editor',{attrs:{"content":_vm.value},on:{"change":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }